import { ReactNode, forwardRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {
  DialogTitle,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

const styles = createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  dense: {
    padding: 0,
  },
});

export type HeaderProps = WithStyles<typeof styles> & {
  className?: string;
  children?: ReactNode;
  dense?: boolean;
};

export const Header = forwardRef<HTMLDivElement, HeaderProps>((props, ref) => {
  const { className, classes, children, dense } = props;
  return (
    <DialogTitle
      disableTypography
      ref={ref}
      className={classNames(classes.root, className, {
        [classes.dense]: dense,
      })}
    >
      {children}
    </DialogTitle>
  );
});

Header.displayName = 'DialogComposite.Header';

export default withStyles(styles)(Header);
